import { useState } from 'react';
import { Grid, Group, NumberInput, Switch, Text } from '@mantine/core';
import SuperAdminArea from '../SuperAdmin/SuperAdminArea';

const FIELDS = [
  {
    name: 'maxRecommendersPerPage',
    label: 'Running product blocks per page',
    defaultValue: 10,
    description:
      'How many product blocks one page may run at the same time. Blocks beyond this cannot be created or switched on. Default 10.',
  },
  {
    name: 'maxDistinctFeedsPerPageLargeCatalog',
    label: 'Distinct product feeds per page',
    defaultValue: 5,
    description:
      'How many different product feeds the blocks running on one page may query. Applies only while the domain is a large catalog. Default 5.',
  },
  {
    name: 'largeCatalogProductThreshold',
    label: 'Large catalog threshold',
    defaultValue: 1000000,
    description: 'From how many products the domain counts as a large catalog. Default 1,000,000 products.',
  },
];

const LimitField = ({ field, value, handleChange }) => {
  const unlimited = value === null;
  // An emptied box is a mid-edit state, not "no limit": only the switch lifts a
  // limit, so the emptied box stays local until a number is typed or focus leaves.
  const [emptied, setEmptied] = useState(false);

  return (
    <Grid mb="md">
      <Grid.Col span={{ base: 12, sm: 4 }} style={{ display: 'flex', alignItems: 'center' }}>
        <label>{field.label}</label>
      </Grid.Col>
      <Grid.Col span={{ base: 12, sm: 8 }}>
        <Group gap="md" align="center" wrap="nowrap">
          <NumberInput
            aria-label={field.label}
            min={1}
            allowDecimal={false}
            allowNegative={false}
            thousandSeparator=","
            disabled={unlimited}
            value={emptied ? '' : (value ?? '')}
            onChange={(next) => {
              if (next === '') {
                setEmptied(true);
                return;
              }
              setEmptied(false);
              handleChange({ target: { name: field.name, value: next } });
            }}
            onBlur={() => setEmptied(false)}
            style={{ flex: 1 }}
          />
          <Switch
            label="Unlimited"
            checked={unlimited}
            onChange={(e) => {
              setEmptied(false);
              handleChange({
                target: { name: field.name, value: e.target.checked ? null : field.defaultValue },
              });
            }}
          />
        </Group>
        <Text size="xs" c="dimmed" mt="xs">
          {field.description}
        </Text>
      </Grid.Col>
    </Grid>
  );
};

const RecommenderPageLimits = ({ domain, handleChange, isSuperAdmin }) => (
  <SuperAdminArea show={isSuperAdmin} mb="md">
    <Text fw={600} mb="sm">
      Product block limits
    </Text>
    {FIELDS.map((field) => (
      <LimitField key={field.name} field={field} value={domain[field.name]} handleChange={handleChange} />
    ))}
  </SuperAdminArea>
);

export default RecommenderPageLimits;
